// removed by extract-text-webpack-plugin
module.exports = {"eyesight__left":"hl64eqLxiua__q_ndsktz","blood_pressure__left":"_1Zf06kIV0zeY0GY-LsvHFq","inputShort":"_8Sww0BDAphBXRQOcBd29r","medicalExaminationForm":"_2kOPifNil4PqazA3C9959v"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/componentStyle/worker/medicalExamination/medicalExamination.scss
// module id = 13392
// module chunks = 0